import { useCallback, useState } from 'react';
import { reelApprovalService } from 'api/services/ReelApprovalService';

const STATUS_APPROVED = 1;
const STATUS_REJECTED = 5;

export function useReelApproval() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const approveReel = useCallback(async (reelId: string) => {
    setLoading(true);
    setError(null);
    try {
      const result = await reelApprovalService.approveOrReject(STATUS_APPROVED, reelId);
      if (!result.isSuccess) {
        setError(result.message ?? 'Gönderi onaylanamadı.');
      }
      return result;
    } catch (err) {
      const msg = err instanceof Error ? err.message : 'Bir hata oluştu.';
      setError(msg);
      return { isSuccess: false, message: msg, statusCode: 0 };
    } finally {
      setLoading(false);
    }
  }, []);

  const rejectReel = useCallback(async (reelId: string, rejectionReason?: string | null) => {
    setLoading(true);
    setError(null);
    try {
      const result = await reelApprovalService.approveOrReject(STATUS_REJECTED, reelId, {
        rejectionReason: rejectionReason ?? null,
      });
      if (!result.isSuccess) {
        setError(result.message ?? 'Gönderi reddedilemedi.');
      }
      return result;
    } catch (err) {
      const msg = err instanceof Error ? err.message : 'Bir hata oluştu.';
      setError(msg);
      return { isSuccess: false, message: msg, statusCode: 0 };
    } finally {
      setLoading(false);
    }
  }, []);

  return { approveReel, rejectReel, loading, error };
}
